export default (value) => {
  const dom = new DOMParser().parseFromString(value, 'text/html');
  const image = dom.body.querySelector('image');
  if(image){
    return image.getAttribute('xlink:href');
  }
}
